import { render, staticRenderFns } from "./EstudianteBoletin.vue?vue&type=template&id=4b2c5185&"
import script from "./EstudianteBoletin.vue?vue&type=script&lang=js&"
export * from "./EstudianteBoletin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports